'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var utils_js = require('../helpers/utils.js');

/**
 * In-page menu for jumping between sections or filtering content.
 * @param {$DOM} $el jQuery element wrapper (containing both anchor-based
 *               menu and select-based menu).
 * @param {object} [options] configuration options
 * @param {string} [options.anchorsWrapper='.in-page-menu'] selector for anchor-
 *                 based navigation menu. Contains anchor tags.
 * @param {string} [options.selectSelector='.in-page-menu--select'] selector for
 *                 select element displayed on mobile
 * @class InPageMenu
 * @namespace ShopifyMarketing
 * @constructor
*/
function InPageMenu(el, options) {
  this.$el = utils_js.isJquery(el) ? el : $(el);

  var config = _Object$assign({
    anchorsWrapper: '.in-page-menu',
    selectSelector: '.in-page-menu--select'
  }, options);

  this.$anchorNav = this.$el.find(config.anchorsWrapper);
  this.$selectNav = this.$el.find(config.selectSelector);
  this.$anchors = this.$anchorNav.find('a');
  this.addEventListeners();
}

InPageMenu.prototype.addEventListeners = function () {
  this.$selectNav.on('change', this.onChange.bind(this));
  this.$anchors.on('click', this.onClick.bind(this));
};

InPageMenu.prototype.onChange = function (evt) {
  this.triggerEvent(evt.currentTarget);
};

InPageMenu.prototype.onClick = function (evt) {
  evt.preventDefault();
  var $target = $(evt.currentTarget);
  this.$anchors.removeClass('js-is-active');
  $target.addClass('js-is-active');
  this.triggerEvent(evt.currentTarget);
};

InPageMenu.prototype.triggerEvent = function (el) {
  var $el = utils_js.isJquery(el) ? el : $(el);
  this.$el.trigger('menu:select', [$el]);
};

module.exports = InPageMenu;
